import { Day } from '@/entities/day';
import { Direction } from '@/entities/direction';
import { Format } from '@/entities/format';
import { Place } from '@/entities/place';
import { ConstructorBlock } from '@/shared/components/constructor/Constructor/Constructor';
import { ProgramDetailCard } from '@/shared/components/sections/ProgramDetailSection/ProgramDetailSection';
import { ImageShape, ParticipationFormat } from '@/shared/lib/types';

export interface TransformedCard {
    id: number;
    slug: string;
    time: string;
    prefix?: string;
    name: string;
    day: string;
    place: Place | undefined;
    directions: string;
    participationFormats: ParticipationFormat[];
    participationDescription?: string;
    companies?: ImageShape[];
    description?: string;
    content?: ConstructorBlock[];
}

export const transformProgramFromApi = (
    data: ProgramDetailCard[],
    directions?: Direction[],
    places?: Place[],
    formats?: Format[],
    days?: Day[],
): TransformedCard[] => {
    return (
        data.map((item) => ({
            id: item.id,
            slug: item.slug,
            time: item.time,
            prefix: item.prefix,
            name: item.name,
            day: days?.find((day) => day.id === item.day)?.day || '',
            place: places?.find((place) => place.id === item.place),
            participationFormats: item.participationFormats,
            participationDescription: item.participationDescription,
            directions:
                item.directions
                    .map((directionId) => directions?.find((direction) => direction.id === directionId)?.name)
                    .filter(Boolean)
                    .join(', ') || '',
            companies: item.companies,
            description: item.description,
            content: item.content,
        })) || []
    );
};
